import { PermissionName } from '@src/contexts/permission-context';
import { getState } from './stateStorage';

export const userHasPermission = (permissionName: PermissionName | undefined) => {
  if (!permissionName) return true;

  const storageState = getState();
  if (!storageState) return;

  const { user } = storageState;
  if (!user) return;

  const userPermissions = user?.RolePermissions || [];

  for (const section of userPermissions) {
    const permission = section.Permissions.find((p) => p.Name === permissionName);
    if (permission) {
      return permission.HasPermission;
    }
  }
  return false;
};
